import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import firebase from "firebase";
import vuetify from '@/plugins/vuetify';

Vue.config.productionTip = false;

var config = {
  apiKey: "AIzaSyDYjbAKiLBYFJjTU1O7NyRBGmXPPNk8lps",
  authDomain: "menu-f5333.firebaseapp.com",
  databaseURL: "https://menu-f5333.firebaseio.com",
  projectId: "menu-f5333",
  storageBucket: "menu-f5333.appspot.com",
  messagingSenderId: "239945174157",
};
firebase.initializeApp(config);

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount("#app");